import { APP_INITIALIZER, Provider } from "@angular/core";
import { provideAppDefaultLanguage } from "./default-language-provider";
import { TranslationService } from "../translation.service";
import { StageLanguageModel } from "../../../models";

function factory(): () => Promise<void> {
  return () => Promise.resolve();
}

/**
 * Initializes the translation feature for the app.
 * The TranslationService is initialized during in app initializer phase
 * to ensure that it is available as soon as possible and will not be tree shaken by AOT compilation.
 *
 * @param stageLanguages Sets the default app language for a specific product stage to the provided value overriding the german ('de')
 * default language that is used most of the time.
 * De value should be two characters long and lowercased: 'de', 'en', 'pl'...
 */
export function initializeGastTranslationService(stageLanguages?: StageLanguageModel[]): Provider[] {
  return [
    provideAppDefaultLanguage(stageLanguages),
    {
      provide: APP_INITIALIZER,
      useFactory: factory,
      deps: [TranslationService],
      multi: true,
    },
  ];
}
